// extracted by mini-css-extract-plugin
export default {"orderboxes":"order-boxes_orderboxes__h0SI-","pagination":"order-boxes_pagination__zeYQV","ar":"order-boxes_ar__G0Jox","modal":"order-boxes_modal__zbwYD"};